import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { fetchMachines, resolveMediaUrl } from "@/lib/api";
import { MACHINES_PAGE } from "@/constants/testIds";
import { useT } from "@/lib/i18n";
import PageHero from "@/components/PageHero";
import SEO from "@/components/SEO";

export default function Machines() {
  const [machines, setMachines] = useState([]);
  const { t } = useT();
  useEffect(() => { fetchMachines().then(setMachines).catch(() => {}); }, []);

  return (
    <div className="pb-24" data-testid={MACHINES_PAGE.container}>
      <SEO
        title="Equipos Dermo Faciales Profesionales | Catálogo Asirox 2026"
        description="Catálogo completo de equipos dermo faciales Asirox: VEGA Pro (hidradermoabrasión), NOVA Triwave (RF+US+microcorrientes), AXIS Med (RF fraccional+microneedling) y Préime DermaFacial 5-en-1. CE médico, ISO 13485."
        keywords="equipos dermo faciales, equipos dermo faciales profesionales, plataforma dermo facial, catálogo aparatología estética, equipos faciales clínicas, hidradermoabrasión profesional, equipo radiofrecuencia facial, microneedling profesional, Asirox VEGA Pro, NOVA Triwave, AXIS Med, Préime DermaFacial"
      />
      <PageHero
        overline="Catálogo · 2026"
        title={t("nav.machines")}
        titleAfter={<span className="block text-white">Profesionales Asirox</span>}
        subtitle="Cuatro plataformas dermo faciales. Una misma obsesión: ingeniería consciente y resultados clínicos perdurables. Desde sistemas de hidradermoabrasión de alto volumen hasta plataformas médicas multi-tecnología y la pionera Préime DermaFacial."
      />
      <div className="max-w-7xl mx-auto px-6 md:px-12 mt-4">
        <div className="space-y-6">
          {machines.map((m, i) => (
            <Link
              key={m.slug}
              to={`/equipos-dermo-faciales/${m.slug}`}
              data-testid={MACHINES_PAGE.card_link(m.slug)}
              className="group grid grid-cols-1 md:grid-cols-12 gap-6 border border-black/15 bg-[#f7ebd9] p-6 md:p-8 card-tilt items-center shadow-[0_18px_45px_-22px_rgba(61,31,10,0.45),0_6px_18px_-8px_rgba(0,0,0,0.12)] hover:shadow-[0_28px_60px_-20px_rgba(61,31,10,0.55),0_10px_24px_-8px_rgba(255,156,0,0.20)]"
            >
              <div className="md:col-span-5 relative aspect-[4/3] overflow-hidden border border-black/10 bg-black">
                <img src={resolveMediaUrl(m.hero_image)} alt={m.name} className="absolute inset-0 w-full h-full object-cover group-hover:scale-105 transition-transform duration-700 opacity-90"/>
                <div className="absolute inset-0 bg-gradient-to-b from-transparent to-black/60"/>
                <p className="absolute bottom-3 left-3 overline overline-on-dark">{m.category}</p>
              </div>
              <div className="md:col-span-7">
                <p className="font-mono text-xs text-black/50">0{i+1} / 0{machines.length}</p>
                <h2 className="font-heading text-3xl md:text-4xl font-bold tracking-tighter mt-2 ink-heading">{m.name}</h2>
                <p className="text-black mt-4 max-w-2xl font-medium">{m.tagline}</p>
                <p className="text-black/75 mt-4 text-sm leading-relaxed max-w-2xl">{m.short_description}</p>
                <div className="flex flex-wrap gap-4 mt-6">
                  <span className="text-xs font-mono font-bold text-[#3D1F0A] border border-[#3D1F0A] px-3 py-1.5">{m.wavelength}</span>
                  <span className="text-xs font-mono text-black border border-black/20 px-3 py-1.5">{m.power}</span>
                  <span className="text-xs font-mono text-black border border-black/20 px-3 py-1.5">{m.spot_size}</span>
                </div>
                <div className="mt-6 inline-flex items-center gap-2 text-[#3D1F0A] font-bold">
                  {t("common.view_full")}
                  <ArrowUpRight size={16} className="group-hover:translate-x-1 group-hover:-translate-y-1 transition-transform"/>
                </div>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </div>
  );
}
